(() => {
  const lang = (document.documentElement.lang || 'en').split('-')[0];
  const T = {
    de: { preorder: 'Vorbestellen', ship: 'Versand ab ', locale: 'de-DE', labels: { Purchased: 'Bestellt', Processing: 'Bearbeitung', Delivered: 'Geliefert' } },
    sv: { preorder: 'Förbeställ', ship: 'Leverans från ', locale: 'sv-SE', labels: { Purchased: 'Köpt', Processing: 'Behandlas', Delivered: 'Levererad' } },
    en: { preorder: 'Preorder', ship: 'Shipping from ', locale: 'en-GB', labels: null }
  }[lang] || { preorder: 'Preorder', ship: 'Shipping from ', locale: 'en-GB', labels: null };
  const preorder = T.preorder;
  const translate = (scope) => {
    const buttons = scope.querySelectorAll('[data-essential-preorder-element="button"]');
    buttons.forEach((button) => {
      const label = button.querySelector('[data-essential-preorder-element="button-text"]');
      if (label && /^Ennakkotilaa!?$/i.test(label.textContent.trim())) {
        label.textContent = preorder;
      }
      if (/^Ennakkotilaa!?$/i.test(button.getAttribute('aria-label') || '')) {
        button.setAttribute('aria-label', preorder);
      }
    });
    scope.querySelectorAll('[data-essential-preorder-element="message"]').forEach((message) => {
      const text = message.textContent.trim();
      const match = /^Toimitukset (\d{1,2})\.(\d{1,2})\.(\d{4}) alkaen!?$/.exec(text);
      if (match) {
        const date = new Date(Date.UTC(Number(match[3]), Number(match[2]) - 1, Number(match[1])));
        message.textContent = T.ship + new Intl.DateTimeFormat(T.locale, {
          day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'
        }).format(date) + '!';
      }
    });
  };
  const translateDelivery = () => {
    if (!T.labels) return;
    document.querySelectorAll('[data-essential-preorder-element="badge-text"]').forEach((badge) => {
      if (badge.textContent.trim() === 'Preorder') badge.textContent = preorder;
    });
    const labels = T.labels;
    document.querySelectorAll('.essential-estimated-delivery-title').forEach((element) => {
      const label = labels[element.textContent.trim()];
      if (label) {
        Array.from(element.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE).forEach((node) => {
          if (labels[node.textContent.trim()]) node.textContent = label;
        });
      }
    });
  };
  translate(document);
  translateDelivery();
  const observer = new MutationObserver((mutations) => {
    translateDelivery();
    if (mutations.some((mutation) => {
      const element = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target : mutation.target.parentElement;
      return element && (element.closest('[data-essential-preorder-element]')
        || Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === Node.ELEMENT_NODE && (node.matches('[data-essential-preorder-element]')
          || node.querySelector('[data-essential-preorder-element]'))));
    })) translate(document);
  });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();